import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-198125d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "HeaderProfileDropdown" }
const _hoisted_2 = { class: "HeaderProfileDropdown__content" }
const _hoisted_3 = { class: "content__email" }
const _hoisted_4 = { class: "content__role" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-out-alt" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item__name" }, "Выход", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.account.state.user_email), 1),
      _createElementVNode("div", _hoisted_4, [
        (!_ctx.account.state.is_loading && !_ctx.account.state.is_failed)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: _normalizeClass(["small", { primary: _ctx.account.state.roles.length > 0 }])
            }, {
              default: _withCtx(() => [
                (_ctx.account.state.roles.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.account.state.roles[0].name), 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Нет роли ")
                    ], 64))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "HeaderProfileDropdown__item",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
    }, _hoisted_7)
  ]))
}